import { render, staticRenderFns } from "./tracking-detail.vue?vue&type=template&id=87a63582"
import script from "./tracking-detail.vue?vue&type=script&lang=js"
export * from "./tracking-detail.vue?vue&type=script&lang=js"
import style0 from "./tracking-detail.vue?vue&type=style&index=0&id=87a63582&prod&lang=css"
import style1 from "./tracking-detail.vue?vue&type=style&index=1&id=87a63582&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports